var interceptor = require('rest/interceptor');

var standardResponse = interceptor({
  response: transform,
});

function transform(response) {
  return {
    url: response.url,
    status: response.status ? response.status.code : undefined,
    headers: response.headers,
    entity: response.entity,
    error: response.error,
    callback: response.request.callback
  };
};

module.exports = standardResponse;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mapbox/lib/standard_response.js
// module id = 253
// module chunks = 0